export const IconStar = () => {
    return (
        <svg
            width="41"
            height="41"
            viewBox="0 0 41 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Icon of a Star</title>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.1749 12.5978C15.6406 11.4958 19.5363 2.84937 19.8199 1.9897C20.1035 1.13003 20.675 0.806392 21.4174 2.45725C22.1598 4.10811 25.5581 11.2938 25.6997 12.343C25.8412 13.3922 26.9612 14.3919 28.2904 14.3919C29.6197 14.3919 38.9731 15.3532 39.9986 15.3532C41.0241 15.3532 41.4662 15.8003 40.3288 16.6129C39.1914 17.4255 31.2447 24.1223 30.6671 24.6686C30.0896 25.2148 29.6858 25.7706 30.1369 27.1643C30.588 28.558 32.737 37.2303 33.0875 38.3176C33.4381 39.4049 32.9306 39.9837 31.522 39.0163C30.1134 38.0489 23.2655 33.9645 22.4257 33.4825C21.586 33.0006 20.1501 32.039 18.0017 33.7402C15.8533 35.4414 10.0434 38.5931 9.03244 39.3356C8.02148 40.0781 7.29918 39.7215 7.76193 38.4385C8.22468 37.1555 10.7924 27.8368 10.975 27.0181C11.1575 26.1995 10.8983 24.9047 9.69865 24.0573C8.49905 23.2098 1.00614 16.8994 0.378561 16.4552C-0.249022 16.011 -0.251404 15.2861 1.58134 15.2861C3.41409 15.2861 11.7449 14.2809 12.8794 14.2809C14.014 14.2809 14.7093 13.6997 15.1749 12.5978Z"
                fill="#313030"
            />
        </svg>
    );
};
